export default function CommandTextService(gettext) {
  'ngInject';

  //for the purpose of extracting texts for translation
  //from template .json files in tugboat API c#
  this.statusText = {
    'Battery Status': gettext('Battery Status'),
    'Unable to retrieve battery level.': gettext('Unable to retrieve battery level.'),
    'Battery level is good.': gettext('Battery level is good.'),
    'Battery level is low.': gettext('Battery level is low.'),
    'Auto Mode': gettext('Auto Mode'),
    'Unable to retrieve Key Position. The equipment may not be turned on.': gettext(
      'Unable to retrieve Key Position. The equipment may not be turned on.',
    ),
    'The key is in auto start position.': gettext('The key is in auto start position.'),
    'The key is not in auto start position. No commands can be sent to the device until it is in Auto Start mode.': gettext(
      'The key is not in auto start position. No commands can be sent to the device until it is in Auto Start mode.',
    ),
    'Modbus Status': gettext('Modbus Status'),
    'Unable to retrieve Modbus status': gettext('Unable to retrieve Modbus status'),
    'Modbus has been detected.': gettext('Modbus has been detected.'),
    'Unable to detect Modbus. The equipment may needs to be turned on': gettext(
      'Unable to detect Modbus. The equipment may needs to be turned on',
    ),
  };

  //commands text from template .json files in tugboat API c#
  // commandName : UIText
  this.commandControlsTemplateText = {
    'Engine Start/Stop': gettext('Engine Start/Stop'),
    Start: gettext('Start'),
    Stop: gettext('Stop'),
    'Start/Stop': gettext('Start/Stop'),
    'AutoStart Enable': gettext('Autostart Enable'),
    'Autostart Enable': gettext('Autostart Enable'),
    'Throttle Control': gettext('Throttle Control'),
    'Desired RPM': gettext('Desired RPM'),
    'Target RPM': gettext('Target RPM'),
  };

  //command names map
  //from commands DB in iceberg
  this.commandNamesMap = {
    '14_pin_connector': gettext('14 Pin Connector'),
    '270_deg_camera': gettext('270 Deg Camera'),
    '2_piece_boom': gettext('2 Piece Boom'),
    'Position 1': gettext('Position 1'),
    'Position 2': gettext('Position 2'),
    'Position 3': gettext('Position 3'),
    'Position 4': gettext('Position 4'),
    'Trime Engine Start': gettext('Trime Engine Start'),
    'Trime Engine Stop': gettext('Trime Engine Stop'),
    'Trime Fault Reset': gettext('Trime Fault Reset'),
    'Trime GCB Off': gettext('Trime GCB Off'),
    'Trime GCB On': gettext('Trime GCB On'),
    'Trime GCB Toggle': gettext('Trime GCB Toggle'),
    'Trime Horn Reset': gettext('Trime Horn Reset'),
    'Trime MCB Off': gettext('Trime MCB Off'),
    'Trime MCB On': gettext('Trime MCB On'),
    'Trime MCB Toggle': gettext('Trime MCB Toggle'),
    active_power_control: gettext('Active Power Control'),
    alarms_drive: gettext('Alarms Drive'),
    alarms_lift: gettext('Alarms Lift'),
    auto_grease: gettext('Auto Grease'),
    auto_tank: gettext('Auto Tank'),
    aux2_aux4_independent: gettext('Aux2 Aux4 Independent'),
    aux_1: gettext('Aux 1'),
    aux_1_pressure_adjustment: gettext('Aux 1 Pressure Adjustment'),
    aux_2: gettext('Aux 2'),
    aux_2_pressure_adjustment: gettext('Aux 2 Pressure Adjustment'),
    aux_4: gettext('Aux 4'),
    back_alarm: gettext('Back Alarm'),
    communication_mode: gettext('Communication Mode'),
    cummins_3_3_engine_start: gettext('Engine Start'),
    cummins_3_3_engine_stop: gettext('Engine Stop'),
    drive_elev_fwd_max: gettext('Drive Elev Fwd Max'),
    drive_elev_rev_max: gettext('Drive Elev Rev Max'),
    drive_fwd_max: gettext('Drive Fwd Max'),
    drive_rev_max: gettext('Drive Rev Max'),
    enable_disable_engine: gettext('Enable Disable Engine'),
    end_periodic_write: gettext('End Periodic Write'),
    engine_auto_stop: gettext('Engine Auto Stop'),
    engine_control: gettext('Engine Control'),
    engine_control_c1: gettext('Engine Control C1'),
    engine_speed_limit: gettext('Engine Speed Limit'),
    foot_accelerator_pedal: gettext('Foot Accelerator Pedal'),
    high_flow: gettext('High Flow'),
    j1939_read: gettext('J1939 Read'),
    lift_height_max: gettext('Lift Height Max'),
    lift_up_max: gettext('Lift Up Max'),
    lockout: gettext('Lockout'),
    locnacelle_engine_start: gettext('Engine Start'),
    locnacelle_engine_stop: gettext('Engine Stop'),
    lofa_autostart_enable: gettext('Autostart Enable'),
    lofa_engine_start: gettext('Engine Start'),
    lofa_engine_stop: gettext('Engine Stop'),
    lofa_throttle_control: gettext('Throttle Control'),
    multifunction_grip: gettext('Multifunction Grip'),
    optional_function_1: gettext('Optional Function 1'),
    optional_function_2: gettext('Optional Function 2'),
    output_control: gettext('Output Control'),
    outrigger: gettext('Outrigger'),
    parking_brake: gettext('Parking Brake'),
    poll: gettext('Poll'),
    radio: gettext('Radio'),
    read_fuel_level: gettext('Read Fuel Level'),
    read_oil_pressure: gettext('Read Oil Pressure'),
    ride_control: gettext('Ride Control'),
    set_accumulator: gettext('Set Accumulator'),
    side_camera: gettext('Side Camera'),
    start_periodic_write: gettext('Start Periodic Write'),
    telemetry_control: gettext('Telemetry Control'),
    travel_alarm: gettext('Travel Alarm'),
    travel_speed_control: gettext('Travel Speed Control'),
    ultrasonic_sensors: gettext('Ultrasonic Sensors'),
    work_time: gettext('Work Time'),
  };

  //user input prompts
  //from commands DB in iceberg
  this.commandPrompts = {
    '14 Pin Connector': gettext('14 Pin Connector'),
    '2 Piece Boom': gettext('2 Piece Boom'),
    '270 Deg Camera': gettext('270 Deg Camera'),
    'AUX 1': gettext('AUX 1'),
    'AUX 2': gettext('AUX 2'),
    'AUX 4': gettext('AUX 4'),
    'Active Power Control': gettext('Active Power Control'),
    'Auto Grease': gettext('Auto Grease'),
    'Auto Tank': gettext('Auto Tank'),
    'Aux 1 Pressure Adjustment': gettext('Aux 1 Pressure Adjustment'),
    'Aux 2 Pressure Adjustment': gettext('Aux 2 Pressure Adjustment'),
    'Aux2 Aux4 Independent': gettext('Aux2 Aux4 Independent'),
    'Back Alarm': gettext('Back Alarm'),
    'Change to': gettext('Change to'),
    'Communication Mode': gettext('Communication Mode'),
    'Desired override duration (seconds)': gettext('Desired override duration (seconds)'),
    'Desired run speed (rpm)': gettext('Desired run speed (rpm)'),
    'Drive speed adjustment in the elevated position (%)': gettext(
      'Drive speed adjustment in the elevated position (%)',
    ),
    'Engine Auto Stop': gettext('Engine Auto Stop'),
    'Engine Speed Limit': gettext('Engine Speed Limit'),
    'Foot Accelerator Pedal': gettext('Foot Accelerator Pedal'),
    'Height adjustment (%)': gettext('Height adjustment (%)'),
    'High Flow': gettext('High Flow'),
    'Maximum speed of lift (%)': gettext('Maximum speed of lift (%)'),
    'Multifunction Grip': gettext('Multifunction Grip'),
    'Optional Function 1': gettext('Optional Function 1'),
    'Optional Function 2': gettext('Optional Function 2'),
    'Output Control': gettext('Output Control'),
    Outrigger: gettext('Outrigger'),
    'Parking Brake': gettext('Parking Brake'),
    'Position 1 Count': gettext('Position 1 Count'),
    'Position 2 Count': gettext('Position 2 Count'),
    'Position 3 Count': gettext('Position 3 Count'),
    'Position 4 Count': gettext('Position 4 Count'),
    Radio: gettext('Radio'),
    'Ride Control': gettext('Ride Control'),
    'Side Camera': gettext('Side Camera'),
    'Speed adjustment (%)': gettext('Speed adjustment (%)'),
    'Telemetry Control': gettext('Telemetry Control'),
    'Travel Alarm': gettext('Travel Alarm'),
    'Travel Speed Control': gettext('Travel Speed Control'),
  };

  //commands parameters valid values
  //from the iceberg DB
  this.commandValidValues = {
    'ALL ON': gettext('ALL ON'),
    'Cancel Telemetry': gettext('Cancel Telemetry'),
    Disable: gettext('Disable'),
    'Disable Lockout': gettext('Disable Lockout'),
    Enable: gettext('Enable'),
    'Enable Lockout': gettext('Enable Lockout'),
    'Engine Speed Low': gettext('Engine Speed Low'),
    'Engine Speed Mid': gettext('Engine Speed Mid'),
    'Engine Start Disable': gettext('Engine Start Disable'),
    Full: gettext('Full'),
    'Limit Unlock': gettext('Limit Unlock'),
    'Momentary On 10 seconds': gettext('Momentary On 10 seconds'),
    'Momentary On 20 seconds': gettext('Momentary On 20 seconds'),
    'Momentary On 30 seconds': gettext('Momentary On 30 seconds'),
    OFF: gettext('OFF'),
    ON: gettext('ON'),
    'ON - Down Only': gettext('ON - Down Only'),
    'ON - Forward Only': gettext('ON - Forward Only'),
    'ON - Reverse Only': gettext('ON - Reverse Only'),
    'ON - Up Only': gettext('ON - Up Only'),
    Off: gettext('Off'),
    On: gettext('On'),
    'Output OFF': gettext('Output OFF'),
    'Output ON': gettext('Output ON'),
    Restricted: gettext('Restricted'),
    'Start Engine': gettext('Start Engine'),
    'Stop Engine': gettext('Stop Engine'),
    'Telemetry Start': gettext('Telemetry Start'),
  };

  //will contain any text that may need to be overridden in the UI
  this.commandsTextMap = {
    ...this.commandNamesMap,
  };
}
